import { COLORS, FONTS, TYPE, SPACING } from "../theme.js";

// Executive — serif name, wide letter-spacing, thick top rule, dense but airy.
export const executiveStyles = {
  meta: { label: "Executive (serif)" },

  page: {
    paddingTop: 52,
    paddingBottom: 52,
    paddingLeft: 60,
    paddingRight: 60,
    backgroundColor: COLORS.white,
    fontFamily: FONTS.sans,
    fontSize: TYPE.body,
    color: COLORS.navy,
    lineHeight: 1.5,
  },

  header: { marginBottom: 16, alignItems: "center" },
  headerTopRule: {
    borderTopWidth: 3,
    borderTopColor: COLORS.navy,
    marginBottom: 10,
  },
  headerName: {
    fontSize: TYPE.name + 4,
    fontFamily: FONTS.serif,
    color: COLORS.navy,
    letterSpacing: 3,
    textTransform: "uppercase",
    textAlign: "center",
    marginBottom: 8,
  },
  headerHeadline: {
    fontSize: TYPE.body,
    color: COLORS.slate,
    marginTop: 14,
    letterSpacing: 1.5,
    textTransform: "uppercase",
    textAlign: "center",
  },
  headerContact: {
    fontSize: TYPE.micro,
    color: COLORS.mute,
    marginTop: 6,
    textAlign: "center",
    letterSpacing: 0.5,
  },
  headerBottomRule: {
    borderBottomWidth: 1,
    borderBottomColor: COLORS.navy,
    marginTop: 10,
  },
  sep: { color: COLORS.mute, marginHorizontal: 8 },

  section: { marginTop: 16 },
  sectionHeadingWrap: { marginBottom: 6 },
  sectionHeading: {
    fontSize: TYPE.body,
    fontFamily: FONTS.serif,
    textTransform: "uppercase",
    letterSpacing: 3,
    color: COLORS.navy,
    marginBottom: 3,
  },
  sectionRule: {
    borderBottomWidth: 1,
    borderBottomColor: COLORS.navy,
  },

  itemGroup: { marginBottom: 12 },
  itemGroupTight: { marginBottom: 5 },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  itemTitle: {
    fontSize: TYPE.itemTitle,
    fontFamily: FONTS.serifBold,
    color: COLORS.navy,
  },
  itemTitleAlt: { fontFamily: FONTS.serif, color: COLORS.slate },
  itemTitleMuted: { fontFamily: FONTS.serif, color: COLORS.slate },
  itemSubtitle: {
    fontSize: TYPE.body,
    fontFamily: FONTS.sansItalic,
    color: COLORS.slate,
    marginTop: 1,
  },
  itemDate: { fontSize: TYPE.meta, color: COLORS.mute, letterSpacing: 0.5 },

  body: {
    fontSize: TYPE.body,
    color: COLORS.navy,
    marginTop: 3,
    lineHeight: 1.55,
  },
  meta: { fontSize: TYPE.meta, color: COLORS.slate, marginTop: 2 },
  chipsLine: { fontSize: TYPE.meta, marginTop: 3, color: COLORS.slate },
  labelStrong: { fontFamily: FONTS.sansBold, color: COLORS.navy },
  italic: { fontFamily: FONTS.sansItalic },

  bullets: { marginTop: 5 },
  bulletRow: { flexDirection: "row", marginBottom: 3 },
  bulletMark: { width: 12, fontSize: TYPE.body, color: COLORS.navy },
  bulletText: {
    flex: 1,
    fontSize: TYPE.body,
    color: COLORS.navy,
    lineHeight: 1.55,
  },

  link: { color: COLORS.navy, textDecoration: "underline" },
  linkSmall: {
    color: COLORS.navy,
    textDecoration: "underline",
    fontSize: TYPE.meta,
  },
};
